import { ApolloClient, gql } from "@apollo/client";
import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";

export interface Dashboard {
  id: number;
  name: string;
  order: number;
}

const GET_DASHBOARDS = gql`
  query GetDashboards($siteId: Float!) {
    dashboards(siteId: $siteId) {
      id
      name
      order
    }
  }
`;

export interface DashboardsApi {
  list: ReadOnlyStore<Dashboard[]>;
  refresh(siteId: number): Promise<Dashboard[]>;
}

export function createDashboardsApi(
  client: ApolloClient<unknown>,
): DashboardsApi {
  const store = createStore<Dashboard[]>([]);
  return {
    list: store.store,
    refresh: async (siteId: number) => {
      try {
        const { data } = await client.query<{ dashboards: Dashboard[] }>({
          query: GET_DASHBOARDS,
          variables: { siteId },
          fetchPolicy: "no-cache",
        });
        const dashboards = data?.dashboards ?? [];
        store.set(dashboards);
        return dashboards;
      } catch (e) {
        console.warn("[shell] dashboards query failed", e);
        store.set([]);
        return [];
      }
    },
  };
}
